<template>
	<div class="item2">
		<img class="logoico" src="../assets/images/logo.png" />
		<back></back>
		<div class="item2box">
			<div class="title">
				<div>智慧篇</div>
			</div>
			
			<div class="content">
				<div class="titles">为虎医伤</div>
				<div class="topss">
					<div class="txt1">
						<a href="javascript:void(0);" @click="isshowvvv = true">
						<img class="vvv" src="../assets/images/item2videoico.png" />
						</a>
						<p>相传，有一天药王孙思邈山中采药，突然被一只老虎拦住去路，药王大吃一惊，想要逃走已是不可能的了，药王随身带着一条用来挑草药的扁担，但要用这条扁担对付老虎这又谈何容易。他—无所措，只是恐惧地盯着老虎。奇怪的是这只老虎并没有向他扑来，却长着大嘴躺在了地上，它以痛苦的眼神看着药王，似平在向他乞求什么，并不停摆动着脑袋。</p>
						<p>药王被眼前情景震惊了，试探着慢慢接近这只庞然大物，只见老虎咽喉里卡着—根很大的骨头。药王想帮老虎取出兽骨，但又扫心取骨疼痛突然闭嘴咬断白己的手臂，这时，他想起扁担两头上的铜环，此铜环是用来挂药箱用的，便取下铜环撑住虎口，然后将手穿过铜环伸入口中，迅速拔出骨头并在伤口处抹上药。药王取下虎口中的铜环后，老虎不停地点头，似平在感谢这位慈悲为怀的医生，随后转身而去。</p>
						<p>自药王铜环撑虎口取骨后，取名'虎撑'，逐渐改造成响器，便是江湖郎中外出时必带之物。出门行医或采药时随身带上"虎撑"，于是成为行医的标志，也是护身符。</p>
						<p>这个故事虽然带有一定的传奇色彩，但体现了孙思邈高超的智慧。患者有时像猛虎一样，既需要被救治，又有可能会伤害到医生，孙思邈用“虎撑”完美解决了这个难题，“虎撑”可以看作孙思邈解决医患矛盾的中介。</p>
						
					</div>
				</div>
				<div class="bottomss">
					<a href="javascript:void(0);" @click="isshowhc = true" class="left"><img src="../assets/images/item2video.png" /></a>
					<div class="txt2">
						<p>进香赔礼。</p>
						<p>同时还必须向孙思邈的牌位</p>
						<p>前没收游医的虎撑和药篮，</p>
						<p>藐祖之嫌，药店的人可以上</p>
						<p>牌位，倘若摇动，便有欺师</p>
						<p>因为药店里都供有孙思邈的</p>
						<p>药店门口时都不能摇动虎撑，</p>
						<p>但不管在什么位置，在经过</p>
						<p>象征医术非常高明。</p>
						<p>高；举过头顶摇动，</p>
						<p>与肩齐平摇动，表示医术较</p>
						<p>表示是一般的郎中；</p>
						<p>规矩：如果放在胸前摇动，</p>
						<p>游医们摇动虎撑时有一定的</p>
						<p>并取名为虎撑。</p>
						<p>作为行医的标志，</p>
						<p>手里也都拿着这样的铁环，</p>
						<p>也有名医孙思邈那样的医术，</p>
						<p>攻击。游医郎中为显示自己</p>
						<p>虎看病并且不会受到它们的</p>
						<p>的弟子，只有药王能够为老</p>
						<p>上它，用于显示他们是药王</p>
						<p>虎撑，医生出门采药时会带</p>
					</div>
					<img class="right" src="../assets/images/item2icotitle.png" />
				</div>
			</div>
		</div>
		<div class="dillog" v-if="isshowhc">
			
			<div class="border">
				<a href="javascript:void(0);" @click="isshowhc = false"><img class="close"
						src="../assets/images/tcclose.png" /></a>
				<iframe width="100%" height="100%" :src="$api.item2IframeUrl"></iframe>
				<img class="smd" src="../assets/images/item2sssss.jpg" />
			</div>
		</div>
		<div class="ddddddd" v-if="isshowvvv">
			<div class="videoboxxxxxx">
				<a class="closesssss" href="javascript:void(0);" @click="isshowvvv = false">
					<img src="../assets/images/tcclose.png" />
				</a>
				<video width="1200" autoplay="autoplay" controls="controls" controlslist="nodownload" :src="$api.item2VideoUrl"></video>
			</div>
		</div>
	</div>
</template>

<script>
	import back from '../components/backhome/back.vue'
	
	import axios from 'axios'
	export default {
		components: {
			back
		},
		data() {
			return {
				token: this.$store.state.token,
				userid: this.$store.state.userid,
				isshowhc: false,
				isshowvvv: false,
			}
		},
		created() {
			
		},
		methods: {
			
		},
		mounted() {

		}
	}
</script>

<style scoped>
	
	.dillog a{
		position: absolute;
		right: -3rem;
		top: -3rem;
	}
	.dillog a img{
		width: 3rem;
		height: 3rem;
	}
	.border{
		border: 3px solid  #ab7b58;
		position: absolute;
		z-index: 99;
		margin: auto;
		left: 2rem;
		right: 2rem;
		top: 2rem;
		bottom: 2rem;
		width: 80rem;
		height: 60rem;
		display: flex;
		flex-wrap: wrap;
	}
	.smd{
		width: 80rem;
		height: 10rem;
		display: block;
	}
	.dillog{
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		background: rgba(0,0,0,0.8);
		z-index: 99;
	}
	iframe{
		border: none;
		height: calc(100% - 10rem - 3px);
		border-bottom: 3px solid #ab7b58;
	}
	.bottomss .left{
		width: 16rem;
		margin-top: 1.3rem;
		padding-left: 2rem;
		
		padding-right: 2rem;
	}
	.left img{
		width: 14rem;
		height: 14rem;
	}
	.bottomss .txt2{
		width: 53rem;
		height: 100%;
		display: flex;
	}
	.bottomss .txt2 p{
		writing-mode: horizontal-tb;
		writing-mode: vertical-rl;
		font-size: 1.142857rem;
		flex: 1;
		margin: 0px auto;
		line-height: calc(53rem / 23);
		padding-top: 1rem;
		padding-bottom: 1rem;
		text-align: left;
		color: #ab7b58;
	}
	.bottomss .right{
		width: auto;
		height: 8rem;
		padding-right: 1rem;
		position: absolute;
		margin: auto;
		bottom: 0;
		top: 0;
		right: 0;
	}
	.vvv{
		float: right;
		display: block;
		width: 20rem;
		padding-left: 1rem;
		padding-bottom: 1rem;
	}
	.txt1{
		padding-top: 4rem;
		padding-left: 3rem;
		padding-right: 3rem;
		padding-bottom: 3rem;
		text-align: left;
		font-size: 1.285714rem;
		line-height: 2rem;
	}
	.txt1 p{
		text-indent: 2em;
	}
	.bottomss{
		width: 100%;
		height: 17rem;
		display: flex;
		position: relative;
	}
	.topss{
		width: 100%;
		height: 31rem;
	}
	.item2 {
		background: url(../assets/images/item5bag.jpg) no-repeat;
		background-size: 120% auto;
		background-position: left center;
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 1;
	}
	.item2 .titles{
		line-height: 2.5rem;
		font-size: 1.6rem;
		font-weight: bold;
		text-align: center;
		color: #5f3519;
		position: absolute;
		margin: auto;
		top: 0;
		left: 0;
		right: 0;
	}

	.item2 .item2box {
		position: absolute;
		z-index: 3;
		left: 1rem;
		top: 8rem;
		right: 1rem;
		bottom: 0;
		text-align: center;
		background: url(../assets/images/videoscrollbag.png) no-repeat;
		background-size: 100% 100%;
		background-position: center;
	}

	.item2 .logoico {
		position: absolute;
		top: 3rem;
		left: 3rem;
		width: 18rem;
	}

	.item2 .title {
		height: 6rem;
		text-align: center;
	}

	.item2 .title div {
		line-height: 6rem;
		width: calc(6rem * 6.39);
		height: 6rem;
		margin: 0px auto;
		background: url(../assets/images/itemtitlebag.png) no-repeat;
		background-size: 100%;
		font-family: 'STXingkai';
		font-size: 3rem;
		color: #FFFFFF;
	}

	.item2 .content {
		width: 80rem;
		height: 50rem;
		margin: 0px auto;
		position: relative;
		margin-top: 2.7rem;
		background: url(../assets/images/item2contentbag.png) no-repeat;
		background-size: 100% 100%;
		color: #ab7b58;
		display: flex;
		flex-wrap: wrap;
	}
	.ddddddd{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0,0,0,0.7);
		z-index: 99;
	}
	.videoboxxxxxx{
		width: 1200px;
		position: absolute;
		margin: auto;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		height: 675px;
	}
	.videoboxxxxxx video{
		position: absolute;
		margin: auto;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
	.closesssss{
		width: 3.571428rem;
		height: 3.571428rem;
		position: absolute;
		top: -3.571428rem;
		right: -3.571428rem;
	}
	.closesssss img{
		width: 3.571428rem;
		height: 3.571428rem;
		display: block;
	}
</style>
